import { render, staticRenderFns } from "./CrsForm.vue?vue&type=template&id=5354cee1&scoped=true"
import script from "./CrsForm.vue?vue&type=script&lang=js"
export * from "./CrsForm.vue?vue&type=script&lang=js"
import style0 from "./CrsForm.vue?vue&type=style&index=0&id=5354cee1&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5354cee1",
  null
  
)

export default component.exports